import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent implements OnInit {
  title: string;
  message: string;

  constructor(public _activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  close(response: boolean) {
    this._activeModal.close(response);
  }
}
